import { useTranslation } from 'react-i18next';

import ReportsAccordion from '../General/ReportsAccordion';

import UsedPoisonsElement from './UsedPoisonsElement';

import { PoisonUsage } from 'api/visitReports/type';

interface UsedPoisonsAccordionProps {
  poisons: PoisonUsage[];
  id: string | undefined;
  slug: string | undefined;
}

const UsedPoisonsAccordion: React.FC<UsedPoisonsAccordionProps> = ({ poisons, id, slug }) => {
  const { t } = useTranslation();

  return (
    <ReportsAccordion
      title={t('UsedPoisons.accordion.title')}
      noDataText={t('UsedPoisons.accordion.no-data')}
      key={t('UsedPoisons.accordion.title')}
      data={poisons}
      mapElement={(data: PoisonUsage) => <UsedPoisonsElement data={data} />}
      slug={slug}
      id={id}
      hasModal
    />
  );
};

export default UsedPoisonsAccordion;
